






# import settings from '@/settings'
import Menus from '@/components/menus'
import roles_table from '@/components/roles_table'

export default {
    name: 'company_roles'

    components: { Menus, roles_table }

    data: ()->
        company_uid: ''

    beforeMount: ()->
        @company_uid = @$store.getters.current_company.uid
}
